/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Capture_UnavailableInputs */

const th_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กล้องหรือหน้าจอไม่พร้อมใช้งาน ตรวจสอบอุปกรณ์แล้วเลือกแหล่งภาพอีกครั้ง`)
};

const en_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The camera or screen is unavailable. Check your device, then choose a source again.`)
};

const ja_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カメラまたは画面を利用できません。端末を確認し、もう一度映像ソースを選んでください。`)
};

const zh_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`摄像头或屏幕不可用。请检查设备后重新选择来源。`)
};

const es_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La cámara o la pantalla no están disponibles. Revisa tu dispositivo y vuelve a elegir una fuente.`)
};

const pt_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A câmera ou a tela estão indisponíveis. Verifique seu aparelho e escolha uma fonte de novo.`)
};

const id_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera atau layar tidak tersedia. Periksa perangkat Anda lalu pilih sumber lagi.`)
};

const fr_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La caméra ou l’écran ne sont pas disponibles. Vérifiez votre appareil, puis choisissez à nouveau une source.`)
};

const tl_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi available ang camera o screen. Suriin ang device mo at pumili muli ng pinagkukunan.`)
};

const vi_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máy ảnh hoặc màn hình không khả dụng. Kiểm tra thiết bị rồi chọn lại nguồn.`)
};

const ko_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`카메라나 화면을 쓸 수 없습니다. 기기를 확인한 뒤 소스를 다시 고르세요.`)
};

const de_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera oder Bildschirm sind nicht verfügbar. Prüfe dein Gerät und wähle dann erneut eine Quelle.`)
};

const ru_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Камера или экран недоступны. Проверьте устройство и выберите источник заново.`)
};

const tr_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera ya da ekran kullanılamıyor. Cihazınızı kontrol edip yeniden kaynak seçin.`)
};

const it_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotocamera o schermo non disponibili. Controlla il dispositivo e riseleziona una sorgente.`)
};

const pl_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera lub ekran są niedostępne. Sprawdź urządzenie i wybierz źródło ponownie.`)
};

const uk_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Камера або екран недоступні. Перевірте пристрій і оберіть джерело знову.`)
};

const hi_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैमरा या स्क्रीन उपलब्ध नहीं। अपना उपकरण जाँचें और फिर स्रोत चुनें।`)
};

const ar_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الكاميرا أو الشاشة غير متاحة. تحقق من جهازك ثم اختر مصدرًا من جديد.`)
};

const ms_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera atau skrin tidak tersedia. Semak peranti anda dan pilih sumber sekali lagi.`)
};

const bn_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্যামেরা বা পর্দা পাওয়া যাচ্ছে না। যন্ত্র দেখে আবার উৎস বেছে নিন।`)
};

const zh_tw2_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相機或螢幕無法使用。請檢查裝置後重新選擇來源。`)
};

const zh_hk2_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相機或熒幕無法使用。請檢查裝置後重新選擇來源。`)
};

const ur_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کیمرا یا اسکرین دستیاب نہیں۔ اپنا آلہ دیکھ کر دوبارہ ذریعہ چنیں۔`)
};

const fa_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دوربین یا صفحه در دسترس نیست. دستگاه‌تان را بررسی و دوباره منبعی برگزینید.`)
};

const sw_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera au skrini haipatikani. Angalia kifaa chako kisha uchague chanzo tena.`)
};

const nl_video_capture_unavailable = /** @type {(inputs: Video_Capture_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera of scherm is niet beschikbaar. Controleer je apparaat en kies opnieuw een bron.`)
};

/**
* | output |
* | --- |
* | "The camera or screen is unavailable. Check your device, then choose a source again." |
*
* @param {Video_Capture_UnavailableInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_capture_unavailable = /** @type {((inputs?: Video_Capture_UnavailableInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Capture_UnavailableInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_capture_unavailable(inputs)
	if (locale === "ja") return ja_video_capture_unavailable(inputs)
	if (locale === "zh") return zh_video_capture_unavailable(inputs)
	if (locale === "es") return es_video_capture_unavailable(inputs)
	if (locale === "pt") return pt_video_capture_unavailable(inputs)
	if (locale === "id") return id_video_capture_unavailable(inputs)
	if (locale === "fr") return fr_video_capture_unavailable(inputs)
	if (locale === "tl") return tl_video_capture_unavailable(inputs)
	if (locale === "vi") return vi_video_capture_unavailable(inputs)
	if (locale === "ko") return ko_video_capture_unavailable(inputs)
	if (locale === "de") return de_video_capture_unavailable(inputs)
	if (locale === "ru") return ru_video_capture_unavailable(inputs)
	if (locale === "tr") return tr_video_capture_unavailable(inputs)
	if (locale === "it") return it_video_capture_unavailable(inputs)
	if (locale === "pl") return pl_video_capture_unavailable(inputs)
	if (locale === "uk") return uk_video_capture_unavailable(inputs)
	if (locale === "hi") return hi_video_capture_unavailable(inputs)
	if (locale === "ar") return ar_video_capture_unavailable(inputs)
	if (locale === "ms") return ms_video_capture_unavailable(inputs)
	if (locale === "bn") return bn_video_capture_unavailable(inputs)
	if (locale === "zh-TW") return zh_tw2_video_capture_unavailable(inputs)
	if (locale === "zh-HK") return zh_hk2_video_capture_unavailable(inputs)
	if (locale === "ur") return ur_video_capture_unavailable(inputs)
	if (locale === "fa") return fa_video_capture_unavailable(inputs)
	if (locale === "sw") return sw_video_capture_unavailable(inputs)
	if (locale === "nl") return nl_video_capture_unavailable(inputs)
	return en_video_capture_unavailable(inputs)
});